// @flow
import * as React from 'react';
import UserGeneratedTextContainer from './UserGeneratedTextContainer';
import type { Answer, Question } from '../../models';
import type { UGCSection } from './UGCSection';
import AuthorInfo from './AuthorInfo';
import classnames from 'classnames';
import UgcLinkContext, { UgcLinkButton } from 'containers/UgcLinkContext';

import {
  qaSectionIcon as icon,
  qaSectionContent as contentCls,
} from './QASection.scss';

type QAItemProps = {
  ugc: Answer | Question,
  mute?: boolean,
  showModQuestionButton?: boolean,
  className?: string,
  verticalHeaderAlignment?: string,
};

export const QAItemIcon = ({ ugctype }: { ugctype: UgcType }) => {
  const char =
    ugctype === 'WDYB' || ugctype === 'Answer' ? 'A' : ugctype.charAt(0);

  return <abbr className={icon}>{char}</abbr>;
};

export const QAItem = (props: QAItemProps) => {
  const {
    ugc,
    mute = false,
    className = '',
    showModQuestionButton = false,
    verticalHeaderAlignment = 'mb2',
  } = props;
  const text = ugc.ugc_archetype === 'Question' ? ugc.question : ugc.answer;
  const style =
    mute === true
      ? {
          opacity: 0.4,
        }
      : null;

  const headingClassName = classnames('ma0 lh-solid', verticalHeaderAlignment);

  return (
    <div className={`flex flex-row items-top ${className}`} style={style}>
      <QAItemIcon ugctype={ugc.ugc_archetype} />
      <div className={contentCls}>
        <h2 className={headingClassName}>
          <UserGeneratedTextContainer
            data-key={ugc.ugctype.toLowerCase()}
            text={text}
          />
        </h2>
        <AuthorInfo ugc={ugc} />
        {showModQuestionButton && (
          <UgcLinkContext.Consumer>
            {linkFn => (
              <div className="dib">
                <UgcLinkButton
                  href={linkFn(ugc)}
                  label="Moderate"
                  darkerButton={true}
                />
              </div>
            )}
          </UgcLinkContext.Consumer>
        )}
      </div>
    </div>
  );
};

export const AnswerSection: UGCSection = {
  Header: props => {
    const ugc = (props.ugc: Answer);
    const parentUgc: Question = ugc.getQuestion();
    const shouldShowModButton =
      props.options.program === 'brand' ? false : true;

    return parentUgc ? (
      <QAItem
        ugc={parentUgc}
        mute
        showModQuestionButton={shouldShowModButton}
      />
    ) : null;
  },

  Content: props => {
    const ugc = (props.ugc: Answer);
    return (
      <div className="ma4 mt0">
        <QAItem ugc={ugc} />
      </div>
    );
  },
  getRelatedContent: (props, options) => null,
};

// $FlowFixMe
class QuestionContent extends React.PureComponent<*, { expanded: boolean }> {
  state = {
    expanded: false,
  };

  toggle = () => {
    this.setState(prevState => ({ expanded: !prevState.expanded }));
  };

  render() {
    const {
      options: { program },
    } = this.props;
    const { expanded } = this.state;

    if (program === 'pwr') return null;

    const question = (this.props.ugc: Question);
    const answers = question.ugc_related_content.filter(
      ugc => ugc && ugc.ugc_archetype === 'Answer'
    );
    const toggleButtonClassName =
      'outline-transparent input-reset button-reset lh-solid pointer flex flex-row bg-transparent b--none blue db w-100 tl ph4 pv3';

    return answers.size ? (
      <div className="bt bw1 b--light-gray pv1">
        <button
          type="button"
          className={toggleButtonClassName}
          onClick={this.toggle}
        >
          <span className="db">{`${answers.size} Other Answer${
            answers.size > 1 ? 's' : ''
          }`}</span>
          <i
            className="fa fa-chevron-down"
            aria-hidden="true"
            style={{ marginLeft: 'auto' }}
          />
        </button>
        {expanded && (
          <div className="xma4">
            {answers.map((ugc, index) => (
              <div className="answer-container mv3" key={index}>
                <QAItem
                  ugc={ugc}
                  key={ugc.ugc_id}
                  className="mh4"
                  verticalHeaderAlignment="mb1"
                />
                {program === 'client' && (
                  <UgcLinkContext.Consumer>
                    {linkFn => (
                      <div className="mh5 dib">
                        <UgcLinkButton href={linkFn(ugc)} label="Moderate" />
                      </div>
                    )}
                  </UgcLinkContext.Consumer>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    ) : (
      <div className="bt bw1 b--light-gray pv1">
        <div className="lh-solid mh4 pv3 moon-gray f5">No Other Answers</div>
      </div>
    );
  }
}

export const QuestionSection: UGCSection = {
  Header: props => {
    const ugc = (props.ugc: Question);

    return <QAItem ugc={ugc} />;
  },
  Content: QuestionContent,
  getRelatedContent: (props, options) => null,
};



// WEBPACK FOOTER //
// ./src/components/ContentSection/QASection.js